import { red } from '~/ui/constants/colors';

export interface IStyleProperty {
  [key: string]: string | number | IStyleProperty;
}

const customStyles = {
  indicatorSeparator: (): IStyleProperty => ({
    display: 'none',
  }),
  multiValue: (provided: IStyleProperty): IStyleProperty => ({
    ...provided,
    color: red,
    backgroundColor: '#FFFBFA',
    border: `1px solid ${red}`,
    borderRadius: 25,
  }),
  multiValueLabel: (provided: IStyleProperty): IStyleProperty => ({
    ...provided,
    color: '#323232',
  }),
  multiValueRemove: (provided: IStyleProperty): IStyleProperty => ({
    ...provided,
    ':hover': {
      cursor: 'pointer',
    },
  }),
};

export default customStyles;
